export default ({ padding }: { padding: number }) => {
	return padding > 0 ? (
		<tr>
			<td style={{ height: `${padding}px` }} />
		</tr>
	) : (
		<></>
	);
};
